// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../assets/fonts/Lato-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../assets/fonts/Lato-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../../assets/fonts/Cairo-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../../assets/fonts/Cairo-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../../assets/fonts/chirp.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../../assets/fonts/chirp-bold-web.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../../../assets/fonts/chirp-heavy-web.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../../../assets/fonts/chirp-medium-web.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../../../assets/fonts/chirp-regular-web.woff", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: LatoRegular;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  font-display: swap;
}
@font-face {
  font-family: LatoBold;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  font-display: swap;
}
@font-face {
  font-family: CairoRegular;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  font-display: swap;
}
@font-face {
  font-family: CairoBold;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  font-display: swap;
}
@font-face {
  font-family: chirp;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  font-display: swap;
}
@font-face {
  font-family: chirpBold;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  font-display: swap;
}
@font-face {
  font-family: chirpHeavy;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  font-display: swap;
}
@font-face {
  font-family: chirpMedium;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
  font-display: swap;
}
@font-face {
  font-family: chirpRegular;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
  font-display: swap;
}
.SideBar_scroll__3\\+8BP::-webkit-scrollbar {
  height: 8px;
}
.SideBar_scroll__3\\+8BP::-webkit-scrollbar-track {
  background-color: var(--bodyColor);
}
.SideBar_scroll__3\\+8BP::-webkit-scrollbar-thumb {
  background-color: var(--mainColor);
}

.SideBar_sidebar__JlvQB {
  width: 285px;
  background-color: var(--bgColor);
  min-height: 100vh;
  top: 51px;
  text-transform: uppercase;
  color: var(--mainColor);
  padding: 30px 0;
  transition: all 0.3s;
}
@media (min-width: 992px) and (max-width: 1200px) {
  .SideBar_sidebar__JlvQB {
    width: 225px;
  }
}
.SideBar_sidebar__JlvQB .MuiContainer-root {
  padding-left: 50px;
  padding-right: 50px;
}
@media (min-width: 992px) and (max-width: 1200px) {
  .SideBar_sidebar__JlvQB .MuiContainer-root {
    padding-left: 20px;
    padding-right: 20px;
  }
}
.SideBar_sidebar__JlvQB li {
  list-style-type: none;
  cursor: pointer;
}
.SideBar_sidebar__JlvQB li svg {
  transition: 0.3s;
}
.SideBar_sidebar__JlvQB .SideBar_mainMenu__-2EIB > li {
  padding-bottom: 20px;
  margin-bottom: 20px;
  border-bottom: 1px solid var(--borderColor);
}
.SideBar_sidebar__JlvQB .SideBar_mainMenu__-2EIB > li .SideBar_listItem__Sv1Og {
  display: flex;
  align-items: center;
  font-weight: 700;
  font-size: 14px !important;
  line-height: 17px;
}
@media (max-width: 992px) {
  .SideBar_sidebar__JlvQB .SideBar_mainMenu__-2EIB > li .SideBar_listItem__Sv1Og {
    font-size: 12px !important;
  }
}
.SideBar_sidebar__JlvQB .SideBar_mainMenu__-2EIB > li .SideBar_listItem__Sv1Og svg:not(:last-child) {
  -webkit-margin-end: 10px;
          margin-inline-end: 10px;
  pointer-events: none;
}
.SideBar_sidebar__JlvQB .SideBar_mainMenu__-2EIB > li .SideBar_listItem__Sv1Og .SideBar_arrow__Vmp6C {
  -webkit-margin-start: auto;
          margin-inline-start: auto;
  pointer-events: none;
}
.SideBar_sidebar__JlvQB .SideBar_mainMenu__-2EIB > li .SideBar_listItem__Sv1Og svg:not(:first-child) {
  max-height: 17px;
  max-width: 30px;
  -webkit-margin-start: auto;
          margin-inline-start: auto;
}
.SideBar_sidebar__JlvQB .SideBar_mainMenu__-2EIB > li span {
  display: flex;
  align-items: center;
  transition: 0.3s;
}
.SideBar_sidebar__JlvQB .SideBar_mainMenu__-2EIB > li span svg {
  -webkit-margin-end: 10px;
          margin-inline-end: 10px;
}
.SideBar_sidebar__JlvQB .SideBar_subList__\\+GBqJ {
  -webkit-padding-start: 25px;
          padding-inline-start: 25px;
  max-height: 0;
  overflow: hidden;
  transition: 0.5s ease-in-out;
}
.SideBar_sidebar__JlvQB .SideBar_subList__\\+GBqJ > li p {
  color: var(--mainColor);
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 10px;
  position: relative;
  -webkit-padding-start: 10px;
          padding-inline-start: 10px;
  font-size: 12px !important;
  line-height: 15px;
}
.SideBar_sidebar__JlvQB .SideBar_subList__\\+GBqJ > li p .SideBar_arrow__Vmp6C {
  pointer-events: none;
}
.SideBar_sidebar__JlvQB .SideBar_subList__\\+GBqJ > li p::before {
  content: "";
  width: 5px;
  height: 5px;
  background-color: var(--secondaryColor);
  border-radius: 100%;
  position: absolute;
  transform: translateY(-50%);
  top: 50%;
}
body[dir=ltr] .SideBar_sidebar__JlvQB .SideBar_subList__\\+GBqJ > li p::before {
  left: 0;
}
body[dir=rtl] .SideBar_sidebar__JlvQB .SideBar_subList__\\+GBqJ > li p::before {
  right: 0;
}
.SideBar_sidebar__JlvQB .SideBar_smallList__3ImYf {
  position: relative;
  -webkit-padding-start: 20px;
          padding-inline-start: 20px;
  max-height: 0;
  overflow: hidden;
  transition: 0.5s ease-in-out;
}
.SideBar_sidebar__JlvQB .SideBar_smallList__3ImYf li {
  font-size: 12px;
  line-height: 15px;
  text-transform: capitalize;
}
.SideBar_sidebar__JlvQB .SideBar_smallList__3ImYf li:hover {
  color: var(--secondaryColor);
}
.SideBar_sidebar__JlvQB .SideBar_smallList__3ImYf li:not(:first-child) {
  margin-top: 10px;
}
.SideBar_sidebar__JlvQB .SideBar_smallList__3ImYf::before {
  position: absolute;
  content: "";
  width: 1px;
  height: 100%;
  background-color: #e0e0e0;
  top: 0;
}
body[dir=ltr] .SideBar_sidebar__JlvQB .SideBar_smallList__3ImYf::before {
  left: 0;
}
body[dir=rtl] .SideBar_sidebar__JlvQB .SideBar_smallList__3ImYf::before {
  right: 0;
}
.SideBar_sidebar__JlvQB .SideBar_smallList__3ImYf a {
  position: relative;
  -webkit-padding-start: 0 !important;
          padding-inline-start: 0 !important;
  transition: 0.3s;
}
.SideBar_sidebar__JlvQB .SideBar_smallList__3ImYf a:hover {
  color: var(--secondaryColor);
}
.SideBar_sidebar__JlvQB .SideBar_smallList__3ImYf li a.active {
  color: var(--secondaryColor);
}
.SideBar_sidebar__JlvQB .SideBar_smallList__3ImYf li a.active::before {
  position: absolute;
  content: "";
  width: 1px;
  height: 100%;
  background-color: var(--secondaryColor);
  top: 0;
}
body[dir=ltr] .SideBar_sidebar__JlvQB .SideBar_smallList__3ImYf li a.active::before {
  left: -20px;
}
body[dir=rtl] .SideBar_sidebar__JlvQB .SideBar_smallList__3ImYf li a.active::before {
  right: -20px;
}
.SideBar_sidebar__JlvQB .SideBar_arrow__Vmp6C {
  width: 10px;
  height: 5px;
}

.active > p svg:not(:first-child) {
  transform: rotate(180deg);
}
.active > .SideBar_subList__\\+GBqJ {
  max-height: 700px;
}

.SideBar_subList__\\+GBqJ li.active .SideBar_smallList__3ImYf {
  margin-top: 15px;
  max-height: 700px;
}
.SideBar_subList__\\+GBqJ li.active svg {
  transform: rotate(180deg);
}

a:hover {
  color: var(--secondaryColor) !important;
}

.SideBar_searchField__y677g {
  display: flex;
  justify-content: space-between;
}
.SideBar_searchField__y677g input {
  border: none;
}
.SideBar_searchField__y677g input::placeholder {
  font-size: 14px;
  line-height: 17px;
  font-weight: 700;
  text-transform: uppercase;
  color: var(--mainColor);
}
.SideBar_searchField__y677g input:focus {
  outline: none;
}
.SideBar_searchField__y677g .SideBar_searchIcon__O7xcX {
  width: 15px;
  height: 15px;
}

.SideBar_userField__ayaA3 {
  display: flex;
  align-items: center;
  text-transform: capitalize;
}
.SideBar_userField__ayaA3 p {
  font-size: 14px !important;
  line-height: 17px;
  font-weight: 700;
}
.SideBar_userField__ayaA3 .SideBar_userType__ys\\+ww {
  color: var(--secondaryColor);
  font-size: 12px !important;
  line-height: 15px;
}
.SideBar_userField__ayaA3 svg {
  -webkit-margin-end: 10px;
          margin-inline-end: 10px;
}

.SideBar_userImg__\\+o54X {
  max-width: 50px;
  height: 50px;
  border-radius: 100%;
  overflow: hidden;
  -webkit-margin-end: 10px;
          margin-inline-end: 10px;
}
.SideBar_userImg__\\+o54X img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.SideBar_sidebarShift__r8x0K {
  width: 0;
  overflow: hidden;
}

.SideBar_mainMenu__-2EIB {
  padding: 0;
  margin: 0;
  list-style: none;
}

.SideBar_mainMenuItem__ghpcp {
  display: flex;
  justify-content: space-between;
  padding-block: 20px;
  cursor: pointer;
}

.SideBar_subMenu__ARfzT {
  height: 0;
  overflow-y: hidden;
}

.SideBar_expand__3EdxP {
  height: auto;
}`, "",{"version":3,"sources":["webpack://./src/app/assets/scss/vars.scss","webpack://./src/app/components/Layout/SideBar/SideBar.module.scss"],"names":[],"mappings":"AAKA;EACE,wBAAA;EACA,4CAAA;EACA,kBAAA;ACJF;ADOA;EACE,qBAAA;EACA,4CAAA;EACA,kBAAA;ACLF;ADOA;EACE,yBAAA;EACA,4CAAA;EACA,kBAAA;ACLF;ADOA;EACE,sBAAA;EACA,4CAAA;EACA,kBAAA;ACLF;ADQA;EACE,kBAAA;EACA,4CAAA;EACA,kBAAA;ACNF;ADSA;EACE,sBAAA;EACA,4CAAA;EACA,kBAAA;ACPF;ADUA;EACE,uBAAA;EACA,4CAAA;EACA,kBAAA;ACRF;ADWA;EACE,wBAAA;EACA,4CAAA;EACA,kBAAA;ACTF;ADYA;EACE,yBAAA;EACA,4CAAA;EACA,kBAAA;ACVF;AD2HE;EACE,WAAA;ACzHJ;AD4HE;EACE,kCAAA;AC1HJ;AD6HE;EACE,kCAAA;AC3HJ;;AAnDA;EACE,YAAA;EACA,gCAAA;EACA,iBAAA;EACA,SAAA;EAMA,yBAAA;EACA,uBAAA;EACA,eAAA;EACA,oBAAA;AAiDF;ADiGE;EC/JF;IAOI,YAAA;EA2DF;AACF;AApDI;EACE,kBAAA;EACA,mBAAA;AAsDN;ADwFE;EChJE;IAKI,kBAAA;IACA,mBAAA;EAuDN;AACF;AApDE;EACE,qBAAA;EACA,eAAA;AAsDJ;AArDI;EACE,gBAAA;AAuDN;AAnDE;EACE,oBAAA;EACA,mBAAA;EACA,2CAAA;AAqDJ;AAnDI;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,0BAAA;EAKA,iBAAA;AAiDN;ADyDE;ECnHE;IAOI,0BAAA;EAuDN;AACF;AArDM;EACE,wBAAA;UAAA,uBAAA;EACA,oBAAA;AAuDR;AArDM;EACE,0BAAA;UAAA,yBAAA;EACA,oBAAA;AAuDR;AArDM;EACE,gBAAA;EACA,eAAA;EACA,0BAAA;UAAA,yBAAA;AAuDR;AApDI;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;AAsDN;AArDM;EACE,wBAAA;UAAA,uBAAA;AAuDR;AAnDE;EACE,2BAAA;UAAA,0BAAA;EACA,aAAA;EACA,gBAAA;EACA,4BAAA;AAqDJ;AAnDM;EACE,uBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EAEA,2BAAA;UAAA,0BAAA;EACA,0BAAA;EACA,iBAAA;AAoDR;AAnDQ;EACE,oBAAA;AAqDV;AAnDQ;EACE,WAAA;EACA,UAAA;EACA,WAAA;EACA,uCAAA;EACA,mBAAA;EACA,kBAAA;EAOA,2BAAA;EACA,QAAA;AA+CV;AAtDU;EACE,OAAA;AAwDZ;AAtDU;EACE,QAAA;AAwDZ;AAhDE;EACE,kBAAA;EACA,2BAAA;UAAA,0BAAA;EACA,aAAA;EACA,gBAAA;EACA,4BAAA;AAkDJ;AAjDI;EACE,eAAA;EACA,iBAAA;EACA,0BAAA;AAmDN;AAlDM;EACE,4BAAA;AAoDR;AAjDI;EACE,gBAAA;AAmDN;AAjDI;EACE,kBAAA;EACA,WAAA;EACA,UAAA;EACA,YAAA;EAOA,yBAAA;EACA,MAAA;AA6CN;AApDM;EACE,OAAA;AAsDR;AApDM;EACE,QAAA;AAsDR;AAjDI;EACE,kBAAA;EACA,mCAAA;UAAA,kCAAA;EACA,gBAAA;AAmDN;AAlDM;EACE,4BAAA;AAoDR;AAjDI;EACE,4BAAA;AAmDN;AAjDM;EACE,kBAAA;EACA,WAAA;EACA,UAAA;EACA,YAAA;EAOA,uCAAA;EACA,MAAA;AA6CR;AApDQ;EACE,WAAA;AAsDV;AApDQ;EACE,YAAA;AAsDV;AA/CE;EACE,WAAA;EACA,WAAA;AAiDJ;;AA5CE;EACE,yBAAA;AA+CJ;AA7CE;EACE,iBAAA;AA+CJ;;AA3CE;EACE,gBAAA;EACA,iBAAA;AA8CJ;AA5CE;EACE,yBAAA;AA8CJ;;AA3CA;EACE,uCAAA;AA8CF;;AA5CA;EACE,aAAA;EACA,8BAAA;AA+CF;AA9CE;EACE,YAAA;AAgDJ;AA/CI;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,yBAAA;EACA,uBAAA;AAiDN;AA/CI;EACE,aAAA;AAiDN;AA9CE;EACE,WAAA;EACA,YAAA;AAgDJ;;AA7CA;EACE,aAAA;EACA,mBAAA;EACA,0BAAA;AAgDF;AA/CE;EACE,0BAAA;EACA,iBAAA;EACA,gBAAA;AAiDJ;AA/CE;EACE,4BAAA;EACA,0BAAA;EACA,iBAAA;AAiDJ;AA/CE;EACE,wBAAA;UAAA,uBAAA;AAiDJ;;AA9CA;EACE,eAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;EACA,wBAAA;UAAA,uBAAA;AAiDF;AAhDE;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AAkDJ;;AA9CA;EACE,QAAA;EACA,gBAAA;AAiDF;;AAzCA;EACE,UAAA;EACA,SAAA;EACA,gBAAA;AA4CF;;AA1CA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;AA6CF;;AA3CA;EACE,SAAA;EACA,kBAAA;AA8CF;;AA5CA;EACE,YAAA;AA+CF","sourcesContent":["//DIRECTIONS\n$ltr: 'body[dir=' ltr ']';\n$rtl: 'body[dir=' rtl ']';\n\n// FONTS\n@font-face {\n  font-family: LatoRegular;\n  src: url(../fonts/Lato-Regular.ttf);\n  font-display: swap;\n}\n\n@font-face {\n  font-family: LatoBold;\n  src: url(../fonts/Lato-Bold.ttf);\n  font-display: swap;\n}\n@font-face {\n  font-family: CairoRegular;\n  src: url(../fonts/Cairo-Regular.ttf);\n  font-display: swap;\n}\n@font-face {\n  font-family: CairoBold;\n  src: url(../fonts/Cairo-Bold.ttf);\n  font-display: swap;\n}\n\n@font-face {\n  font-family: chirp;\n  src: url(../fonts/chirp.ttf);\n  font-display: swap;\n}\n\n@font-face {\n  font-family: chirpBold;\n  src: url(../fonts/chirp-bold-web.woff);\n  font-display: swap;\n}\n\n@font-face {\n  font-family: chirpHeavy;\n  src: url(../fonts/chirp-heavy-web.woff);\n  font-display: swap;\n}\n\n@font-face {\n  font-family: chirpMedium;\n  src: url(../fonts/chirp-medium-web.woff);\n  font-display: swap;\n}\n\n@font-face {\n  font-family: chirpRegular;\n  src: url(../fonts/chirp-regular-web.woff);\n  font-display: swap;\n}\n\n$latoRegular: 'LatoRegular', 'CairoRegular', sans-serif;\n$latoBold: 'LatoBold', 'CairoBold', sans-serif;\n$CairoRegular: 'CairoRegular', 'LatoRegular', sans-serif;\n$CairoBold: 'CairoBold', 'LatoBold', sans-serif;\n\n// COMMON STYLES\n%tablesTitle {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n%pageTitle {\n  #{$ltr} & {\n    font-family: $latoBold !important;\n  }\n  #{$rtl} & {\n    font-family: $CairoBold !important;\n  }\n  font-size: 18px;\n  text-transform: uppercase;\n  position: relative;\n  margin-bottom: 40px;\n\n  &::before {\n    content: '';\n    position: absolute;\n    start: 0;\n    bottom: -10px;\n    border: 2px solid var(--secondaryColor);\n    width: 42px;\n    background-color: var(--secondaryColor);\n  }\n}\n\n%centeredHrVr {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  -webkit-transform: translate(-50%, -50%);\n  -moz-transform: translate(-50%, -50%);\n  -ms-transform: translate(-50%, -50%);\n  -o-transform: translate(-50%, -50%);\n}\n\n// MIXINS\n@mixin fontSize($size) {\n  @if ($size == 10) {\n    font-size: 10px !important;\n  } @else if ($size == 12) {\n    font-size: 12px !important;\n  } @else if($size == 14) {\n    font-size: 14px !important;\n    #{$ltr} & {\n      font-family: $latoBold !important;\n    }\n    #{$rtl} & {\n      font-family: $CairoBold !important;\n    }\n  } @else if($size == 16) {\n    font-size: 16px !important;\n    #{$ltr} & {\n      font-family: $latoBold !important;\n    }\n    #{$rtl} & {\n      font-family: $CairoBold !important;\n    }\n  } @else if($size == 18) {\n    font-size: 18px !important;\n    #{$ltr} & {\n      font-family: $latoBold !important;\n    }\n    #{$rtl} & {\n      font-family: $CairoBold !important;\n    }\n  } @else if($size == 24) {\n    font-size: 24px !important;\n    #{$ltr} & {\n      font-family: $latoBold !important;\n    }\n    #{$rtl} & {\n      font-family: $CairoBold !important;\n    }\n  } @else if ($size == 48) {\n    #{$ltr} & {\n      font-family: $latoBold !important;\n    }\n    #{$rtl} & {\n      font-family: $CairoBold !important;\n    }\n    font-size: 48px !important;\n    color: #606060;\n  }\n}\n\n// Responsive Mixin\n@mixin Sm {\n  @media (max-width: 992px) {\n    @content;\n  }\n}\n\n@mixin Md {\n  @media (min-width: 992px) and (max-width: 1200px) {\n    @content;\n  }\n}\n\n.scroll {\n  &::-webkit-scrollbar {\n    height: 8px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background-color: var(--bodyColor);\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background-color: var(--mainColor);\n  }\n}\n","@import 'app/assets/scss/vars.scss';\n\n.sidebar {\n  width: 285px;\n  background-color: var(--bgColor);\n  min-height: 100vh;\n  top: 51px;\n\n  @include Md {\n    width: 225px;\n  }\n\n  text-transform: uppercase;\n  color: var(--mainColor);\n  padding: 30px 0;\n  transition: all 0.3s;\n  :global {\n    .MuiContainer-root {\n      padding-left: 50px;\n      padding-right: 50px;\n\n      @include Md {\n        padding-left: 20px;\n        padding-right: 20px;\n      }\n    }\n  }\n  li {\n    list-style-type: none;\n    cursor: pointer;\n    svg {\n      transition: 0.3s;\n    }\n  }\n\n  .mainMenu > li {\n    padding-bottom: 20px;\n    margin-bottom: 20px;\n    border-bottom: 1px solid var(--borderColor);\n\n    .listItem {\n      display: flex;\n      align-items: center;\n      font-weight: 700;\n      font-size: 14px !important;\n\n      @include Sm {\n        font-size: 12px !important;\n      }\n      line-height: 17px;\n      svg:not(:last-child) {\n        margin-inline-end: 10px;\n        pointer-events: none;\n      }\n      .arrow {\n        margin-inline-start: auto;\n        pointer-events: none;\n      }\n      svg:not(:first-child) {\n        max-height: 17px;\n        max-width: 30px;\n        margin-inline-start: auto;\n      }\n    }\n    span {\n      display: flex;\n      align-items: center;\n      transition: 0.3s;\n      svg {\n        margin-inline-end: 10px;\n      }\n    }\n  }\n  .subList {\n    padding-inline-start: 25px;\n    max-height: 0;\n    overflow: hidden;\n    transition: 0.5s ease-in-out;\n    & > li {\n      p {\n        color: var(--mainColor);\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        margin-top: 10px;\n        position: relative;\n\n        padding-inline-start: 10px;\n        font-size: 12px !important;\n        line-height: 15px;\n        .arrow {\n          pointer-events: none;\n        }\n        &::before {\n          content: '';\n          width: 5px;\n          height: 5px;\n          background-color: var(--secondaryColor);\n          border-radius: 100%;\n          position: absolute;\n          #{$ltr} & {\n            left: 0;\n          }\n          #{$rtl} & {\n            right: 0;\n          }\n          transform: translateY(-50%);\n          top: 50%;\n        }\n      }\n    }\n  }\n  .smallList {\n    position: relative;\n    padding-inline-start: 20px;\n    max-height: 0;\n    overflow: hidden;\n    transition: 0.5s ease-in-out;\n    li {\n      font-size: 12px;\n      line-height: 15px;\n      text-transform: capitalize;\n      &:hover {\n        color: var(--secondaryColor);\n      }\n    }\n    li:not(:first-child) {\n      margin-top: 10px;\n    }\n    &::before {\n      position: absolute;\n      content: '';\n      width: 1px;\n      height: 100%;\n      #{$ltr} & {\n        left: 0;\n      }\n      #{$rtl} & {\n        right: 0;\n      }\n      background-color: #e0e0e0;\n      top: 0;\n    }\n    a {\n      position: relative;\n      padding-inline-start: 0 !important;\n      transition: 0.3s;\n      &:hover {\n        color: var(--secondaryColor);\n      }\n    }\n    li a:global(.active) {\n      color: var(--secondaryColor);\n\n      &::before {\n        position: absolute;\n        content: '';\n        width: 1px;\n        height: 100%;\n        #{$ltr} & {\n          left: -20px;\n        }\n        #{$rtl} & {\n          right: -20px;\n        }\n        background-color: var(--secondaryColor);\n        top: 0;\n      }\n    }\n  }\n  .arrow {\n    width: 10px;\n    height: 5px;\n  }\n}\n\n:global(.active) {\n  & > p svg:not(:first-child) {\n    transform: rotate(180deg);\n  }\n  & > .subList {\n    max-height: 700px;\n  }\n}\n.subList li:global(.active) {\n  .smallList {\n    margin-top: 15px;\n    max-height: 700px;\n  }\n  svg {\n    transform: rotate(180deg);\n  }\n}\na:hover {\n  color: var(--secondaryColor) !important;\n}\n.searchField {\n  display: flex;\n  justify-content: space-between;\n  input {\n    border: none;\n    &::placeholder {\n      font-size: 14px;\n      line-height: 17px;\n      font-weight: 700;\n      text-transform: uppercase;\n      color: var(--mainColor);\n    }\n    &:focus {\n      outline: none;\n    }\n  }\n  .searchIcon {\n    width: 15px;\n    height: 15px;\n  }\n}\n.userField {\n  display: flex;\n  align-items: center;\n  text-transform: capitalize;\n  p {\n    font-size: 14px !important;\n    line-height: 17px;\n    font-weight: 700;\n  }\n  .userType {\n    color: var(--secondaryColor);\n    font-size: 12px !important;\n    line-height: 15px;\n  }\n  svg {\n    margin-inline-end: 10px;\n  }\n}\n.userImg {\n  max-width: 50px;\n  height: 50px;\n  border-radius: 100%;\n  overflow: hidden;\n  margin-inline-end: 10px;\n  img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n  }\n}\n// bassem\n.sidebarShift {\n  width: 0;\n  overflow: hidden;\n  // #{$ltr} & {\n  //   left: -285px;\n  // }\n  // #{$rtl} & {\n  //   right: -285px;\n  // }\n}\n.mainMenu {\n  padding: 0;\n  margin: 0;\n  list-style: none;\n}\n.mainMenuItem {\n  display: flex;\n  justify-content: space-between;\n  padding-block: 20px;\n  cursor: pointer;\n}\n.subMenu {\n  height: 0;\n  overflow-y: hidden;\n}\n.expand {\n  height: auto;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"scroll": `SideBar_scroll__3+8BP`,
	"sidebar": `SideBar_sidebar__JlvQB`,
	"mainMenu": `SideBar_mainMenu__-2EIB`,
	"listItem": `SideBar_listItem__Sv1Og`,
	"arrow": `SideBar_arrow__Vmp6C`,
	"subList": `SideBar_subList__+GBqJ`,
	"smallList": `SideBar_smallList__3ImYf`,
	"searchField": `SideBar_searchField__y677g`,
	"searchIcon": `SideBar_searchIcon__O7xcX`,
	"userField": `SideBar_userField__ayaA3`,
	"userType": `SideBar_userType__ys+ww`,
	"userImg": `SideBar_userImg__+o54X`,
	"sidebarShift": `SideBar_sidebarShift__r8x0K`,
	"mainMenuItem": `SideBar_mainMenuItem__ghpcp`,
	"subMenu": `SideBar_subMenu__ARfzT`,
	"expand": `SideBar_expand__3EdxP`
};
export default ___CSS_LOADER_EXPORT___;
